import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transfer-tip" }
const _hoisted_2 = { style: {"align-items":"center","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"margin-left":"10px"} }

import {ref} from 'vue'
import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {initEmptyParam} from '@/hooks/useInitParam'
import {getListData} from '@/service/main/system'
import {useStore} from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferTip',
  setup(__props) {

initEmptyParam()

const store = useStore()
const queryParam = ref({})

store.commit('system/changeQueyryInfo', queryParam.value)

//定义筛选规则
const filterRules = [
  '满足以下任意条件：',
  '条件1：新客加进来，查近30天内是否添加过业务员，有加过且和业务员还是好友 不判断有没有回复 或 双方语音通话，直接打标签转走',
  '条件2：30天内没加过 或 有加过且已不是好友， 查近180天是否添加过业务员，有加过且和业务员还是好友，且30天内客户有回复过消息，或者双方有语音通话过，打标签转走'
]

const getUsedBy = async () => {
  let userList = await getListData('/main/enterpriseWechat/dingUser/listAll', {});
  const userOptions = userList.map((item: any) => {
    return {title: item.userName, value: item.userName};
  })
  const usedByItem = searchFormConfig.formItems.find(item => item.field === 'usedBy');
  usedByItem!.options = userOptions;
}
getUsedBy()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'groupId'
  )
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}

getDept()

const getCompanyList = async () => {
  const companyList = await getListData('/main/enterpriseWechat/config/listAll', {})
  const companyItem = searchFormConfig.formItems.find(
    (item) => item.field === 'belongCorpId'
  )
  if (companyItem) {
    companyItem.options = companyList.map((item: any) => {
      return {title: item.name, value: item.corPid || item.corpId || item.id}
    })
  }
}
getCompanyList()

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'sourceLabel')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const resetCb = () => {
  return queryParam.value
}

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "transferTip",
      filterRules: filterRules
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.nickName), 1)
        ])
      ]),
      takeoverStatus: _withCtx((scope) => [
        (scope.row.takeoverStatus === 1)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "success"
            }, {
              default: _withCtx(() => [
                _createTextVNode("接替完毕")
              ]),
              _: 1
            }))
          : (scope.row.takeoverStatus === 2)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("等待接替")
                ]),
                _: 1
              }))
            : (scope.row.takeoverStatus === 3)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("客户拒绝")
                  ]),
                  _: 1
                }))
              : (scope.row.takeoverStatus === 4)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 3,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("接替达上限")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})